import { getEmployeeFields } from "components/user/config";
import { getItemFromCollection } from "directus/src/operations";

export async function fetchTeamData({ teamId }) {
  try {
    const query = {
      fields: [
        "status",
        getEmployeeFields("lead"),
        "department.id",
        getEmployeeFields("employees.employee"),
      ],
    };
    const response = await getItemFromCollection("teams", teamId, query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}